__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "prime-ui";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(623), __webpack_require__.e(706)]).then(() => (() => (__webpack_require__(32706))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(289), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(83051))))));
			register("@mui/material", "9.2.0", () => (Promise.all([__webpack_require__.e(577), __webpack_require__.e(688), __webpack_require__.e(249), __webpack_require__.e(289), __webpack_require__.e(195), __webpack_require__.e(333)]).then(() => (() => (__webpack_require__(41688))))));
			register("@mui/system", "9.2.0", () => (Promise.all([__webpack_require__.e(623), __webpack_require__.e(577), __webpack_require__.e(365), __webpack_require__.e(289), __webpack_require__.e(195)]).then(() => (() => (__webpack_require__(82365))))));
			register("react-dom", "19.2.7", () => (() => (__webpack_require__(78325))), 1);
			register("react/jsx-runtime", "19.2.7", () => (() => (__webpack_require__(62540))), 1);
			register("react", "19.2.7", () => (() => (__webpack_require__(63696))), 1);
			initExternal(63430);
			initExternal(92220);
			initExternal(71068);
			initExternal(31984);
			initExternal(45309);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};